import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactHero = ({ onEmergencyClick, onScheduleClick }) => {
  return (
    <section className="relative bg-gradient-to-br from-primary via-primary to-secondary text-primary-foreground py-12 md:py-16 lg:py-20 overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-32 h-32 md:w-48 md:h-48 lg:w-64 lg:h-64 border-2 border-primary-foreground rounded-full"></div>
        <div className="absolute bottom-10 right-10 w-24 h-24 md:w-36 md:h-36 lg:w-48 lg:h-48 border-2 border-primary-foreground rounded-full"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 bg-accent text-accent-foreground px-4 py-2 rounded-full mb-4 md:mb-6">
            <Icon name="Phone" size={20} />
            <span className="font-accent text-sm md:text-base">24/7 Emergency Response</span>
          </div>

          <h1 className="font-headline font-bold text-3xl md:text-4xl lg:text-5xl mb-4 md:mb-6">
            Get Expert Help Now
          </h1>

          <p className="font-body text-base md:text-lg lg:text-xl opacity-90 mb-6 md:mb-8 lg:mb-10">
            30+ years of trusted service. Multiple ways to reach us. Immediate response for emergencies.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button
              variant="default"
              size="lg"
              onClick={onEmergencyClick}
              className="w-full sm:w-auto bg-accent hover:bg-accent/90 text-accent-foreground emergency-cta"
              iconName="Phone"
              iconPosition="left"
            >
              Emergency: 082 793 5785
            </Button>

            <Button
              variant="outline"
              size="lg"
              onClick={onScheduleClick}
              className="w-full sm:w-auto bg-primary-foreground text-primary hover:bg-primary-foreground/90"
              iconName="Calendar"
              iconPosition="left"
            >
              Schedule Callback
            </Button>
          </div>

          <div className="mt-6 md:mt-8 flex flex-wrap justify-center gap-4 md:gap-6 lg:gap-8 text-sm md:text-base">
            <div className="flex items-center gap-2">
              <Icon name="Clock" size={18} />
              <span>24/7 Available</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="MapPin" size={18} />
              <span>Local Service</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Award" size={18} />
              <span>30+ Years Experience</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;